import { instance } from "../axios"
import type { AxiosRequestConfig } from "axios"
import type {
    UploadFileInfoResponse,
    UploadFileListResponse,
    UploadListResponse,
    UploadStatusListResponse,
    UploadTypeListResponse,
} from "./types"

// 取得 uploads 列表
export function getUploadsFiles(config: AxiosRequestConfig = {}) {
    return instance.request<UploadListResponse>({
        url: "/datahubs/uploads/",
        method: "get",
        ...config,
    })
}

// 取得 上傳類型列表
export function getUploadsFilesType(config: AxiosRequestConfig = {}) {
    return instance.request<UploadTypeListResponse>({
        url: "/datahubs/uploads/types/",
        method: "get",
        ...config,
    })
}

// 取得 上傳狀態列表
export function getUploadsFilesStatus(config: AxiosRequestConfig = {}) {
    return instance.request<UploadStatusListResponse>({
        url: "/datahubs/uploads/status/",
        method: "get",
        ...config,
    })
}

// 上傳 upload 檔案
export function uploadUploadFile(config: AxiosRequestConfig = {}) {
    return instance.request<void>({
        url: `/datahubs/uploads/`,
        method: "post",
        ...config,
    })
}

// 下載 上傳類型 範本檔案
export function downloadSampleFile(
    uploadType: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<Blob>({
        url: `/datahubs/uploads/${uploadType}/template/`,
        method: "get",
        ...config,
    })
}

// 下載 uploads 檔案
export function downloadUploadFile(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<void>({
        url: `/datahubs/uploads/${uuid}/export/`,
        method: "get",
        ...config,
    })
}

// 刪除 uploads 檔案
export function deleteUploadFile(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<void>({
        url: `/datahubs/uploads/${uuid}/`,
        method: "delete",
        ...config,
    })
}

// 取得 uploads 資訊
export function getUploadFileInfo(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<UploadFileInfoResponse>({
        url: `/datahubs/uploads/${uuid}/`,
        method: "get",
        ...config,
    })
}

// 取得 uploads 資料列表
export function getUploadFileList(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<UploadFileListResponse>({
        url: `/datahubs/uploads/${uuid}/list/`,
        method: "get",
        ...config,
    })
}
